/*
  Barcode format codes
  https://www.dynamsoft.com/barcode-reader/docs/web/programming/javascript/api-reference/enum/EnumBarcodeFormat.html
*/

export enum BarcodeFormat {
  BF_ALL = 0xFE3FFFFF,
  BF_ONED = 0x3007FF,
  BF_GS1_DATABAR = 0x3F800,
  BF_CODE_39 = 0x1,
  BF_CODE_128 = 0x2,
  BF_CODE_93 = 0x4,
  BF_CODABAR = 0x8,
  BF_CODE_11 = 0x200000,
  BF_ITF = 0x10,
  BF_EAN_13 = 0x20,
  BF_EAN_8 = 0x40,
  BF_UPC_A = 0x80,
  BF_UPC_E = 0x100,
  BF_INDUSTRIAL_25 = 0x200,
  BF_CODE_39_EXTENDED = 0x400,
  BF_GS1_DATABAR_OMNIDIRECTIONAL = 0x800,
  BF_GS1_DATABAR_TRUNCATED = 0x1000,
  BF_GS1_DATABAR_STACKED = 0x2000,
  BF_GS1_DATABAR_STACKED_OMNIDIRECTIONAL = 0x4000,
  BF_GS1_DATABAR_EXPANDED = 0x8000,
  BF_GS1_DATABAR_EXPANDED_STACKED = 0x10000,
  BF_GS1_DATABAR_LIMITED = 0x20000,
  BF_PATCHCODE = 0x40000,
  BF_PDF417 = 0x2000000,
  BF_QR_CODE = 0x4000000,
  BF_DATAMATRIX = 0x8000000,
  BF_AZTEC = 0x10000000,
  BF_MAXICODE = 0x20000000,
  BF_MICRO_QR = 0x40000000,
  BF_MICRO_PDF417 = 0x80000,
  BF_GS1_COMPOSITE = 0x80000000,
  BF_MSI_CODE = 0x100000,
  BF_NULL = 0x00
}
